// Import mutations
import { GET_PLACES } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_PLACES] (state, places) {
    state.all = places
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/places.js